import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from 'react-helmet';
import Casestudyback from '../../../../Component/Casestudyback'
import Banner from "../../../../asset/images/insight/case_studies/banner-cutting-cyber-bordereaux-processing.webp"
import { Link } from 'react-router-dom';

export default function CuttingCyberBordereaux() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Helmet><meta charset="UTF-8" />
                <meta charset="UTF-8" />
                <title>Cyber Bordereaux Automation Cuts 80% Processing Time for Global Insurer</title>
                <meta name="description" content="Discover how Cyber Bordereaux Automation reduced processing time by 80%, improved accuracy, and enabled scalable operations for a global insurer." />
                <link rel="canonical" href="https://decimalpointanalytics.com/case-study/cyber-bordereaux-automation-global-insurer" />
            </Helmet>

            <Box id="case-studies" className='section sec_bg new_cs' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>
                        <Grid item lg={9} md={9} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Success Stories
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Cutting Cyber Bordereaux Processing Time <span className='lower'>by</span> 80% <span className='lower'>for a</span> Global Insurer
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <img loading="lazy" src={Banner} className='w100' alt='Banner' />
                    </Box>

                    <Box className='whitebx'>

                        <Box>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Client Overview
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                A global leader in insurance and reinsurance services, this client delivers advanced insurance analytics and risk management solutions. Their operations span multiple geographies, with a strong emphasis on transforming data into strategic insights.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Problem Statement
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                The client managed detailed cyber insurance data from multiple cover holders, but manual processing of bordereaux files consumed an average of 12 hours per cycle. The approach led to:
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Repetitive, time-consuming tasks
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Analyst fatigue and reporting delays
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Increased risk due to data inconsistencies
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Limited scalability as data volumes surged
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Solution Provided
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                Decimal Point Analytics deployed an <Link to="/catastrophe-modeling-services" className='link'>automated data processing solution</Link> customized for cyber bordereaux reporting. The end-to-end system:
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Ingested files from 5+ cover holders with varying formats
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Applied real-time validation rules to ensure data integrity
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Automated transformations and generated structured outputs
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Integrated seamlessly with the client’s internal reporting systems
                                        </Typography>
                                    </li>
                                </ul>
                                Explore our Real-time Data Feed Solutions and Unstructured Data Processing Services to discover how we simplify complex reporting workflows.
                            </Typography>
                        </Box>


                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Outcome
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            80% reduction in processing time
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Significant drop in manual errors and rework
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Greater visibility and control over reporting timelines
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Scalable operations to support future data growth
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>

                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Key Takeaway
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                Automation of cyber bordereaux workflows freed up analyst bandwidth, ensured audit-ready data, and enabled faster, more confident decision-making—supporting both compliance and scale.
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <Link to="/contact-us#contact_form" className='link'>Let’s talk</Link> about modernizing your workflows with intelligent automation, resulting in improved efficiency.
                            </Typography>

                        </Box>
                    </Box>

                    <Casestudyback />

                </Container>
            </Box>
        </>
    );
}